import { toast } from 'react-toastify';

export function copyToClipboard(str: string | number, successMessage?: string) {
  navigator.clipboard.writeText(String(str));
  if (successMessage) toast.success(successMessage);
}
